export const MODEL_SPOTTING_GROUP_ADD_RECORDS = 'MODEL_SPOTTING_GROUP_ADD_RECORDS';
export const MODEL_SPOTTING_GROUP_ADD_RECORD = 'MODEL_SPOTTING_GROUP_ADD_RECORD';
export const MODEL_SPOTTING_GROUP_REMOVE_RECORDS = 'MODEL_SPOTTING_GROUP_REMOVE_RECORDS';
export const MODEL_SPOTTING_GROUP_REMOVE_RECORD = 'MODEL_SPOTTING_GROUP_REMOVE_RECORD';
export const MODEL_SPOTTING_GROUP_SET_LIST = 'MODEL_SPOTTING_GROUP_SET_LIST';
export const MODEL_SPOTTING_GROUP_SET_RECORDS = 'MODEL_SPOTTING_GROUP_SET_RECORDS';
export const MODEL_SPOTTING_GROUP_IDENTITY = 'groupName';
